import { useEffect } from "react";

export const useScreenResize = (
  breakpoint: number, //in pixels
  callback: (val: boolean) => void,
): void => {
  const handleResize = () => {
    if (typeof window === "undefined") {
      return;
    }

    if (window.innerWidth <= breakpoint) {
      callback(false);
    }

    if (window.innerWidth > breakpoint) {
      callback(true);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });
};
